import React from 'react';
import { FormattedMessage } from 'react-intl';
import ConfirmModal from '../../../_shared/components/ConfirmModal';

const ProposalErrorModalContainer = ({
  isProposalErrorModalOpen,
  proposalErrorMessage,
  proposalErrorTitle,
  proposalErrorMessageValues,
  setIsProposalErrorModalOpen
}) => {
  const confirmModalLogic = [
    {
      msg: (
        <FormattedMessage
          id={proposalErrorMessage}
          values={{
            name: proposalErrorMessageValues.name,
            offer: proposalErrorMessageValues.offer,
            floorPrice: proposalErrorMessageValues.floorPrice
          }}
        />
      ),
      title: <FormattedMessage id={proposalErrorTitle} />,
      confirmLabel: <FormattedMessage id="modal.ok" />,
      onConfirm: () => () => setIsProposalErrorModalOpen(false)
    }
  ];

  return (
    <ConfirmModal
      modalLogic={confirmModalLogic}
      isOpen={isProposalErrorModalOpen}
    />
  );
};

export default ProposalErrorModalContainer;
